import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TipoDocumentoModel } from './types/tipo.documentos.type';
import { combineLatest } from 'rxjs';
import { Establecimiento, YaloDataAccessService } from '@core/yalo/data-access';
import { EstablecimientoContador } from '../../types/configuracion.types';
import { catchError } from 'rxjs/operators';

@Injectable()
export class EstablecimientosService {
  readonly establecimientosInfo$ = combineLatest([
    this.yaloDataAccess.getEstablecimientos(),
    this.http.get<EstablecimientoContador>(
      `${environment.API_URL}/Subscripcion/Establecimientos/Count`
    ),
  ]);

  constructor(
    private http: HttpClient,
    private yaloDataAccess: YaloDataAccessService
  ) {}

  // TODO: update references
  getEstablecimientos() {
    return this.http.get<any>(`${environment.API_URL}/Establecimientos/`);
  }

  getEstablecimientoId(CodEstablecimiento: number) {
    return this.http.get<any>(
      `${environment.API_URL}/Establecimientos/` + CodEstablecimiento
    );
  }

  postEstablecimientos(EstablecimientoModel) {
    return this.http.post<any>(
      `${environment.API_URL}/Establecimientos/`,
      EstablecimientoModel
    );
  }

  putEstablecimientos(CodEstablecimiento: number, EstablecimientoModel) {
    return this.http.put(
      `${environment.API_URL}/Establecimientos/` + CodEstablecimiento,
      EstablecimientoModel
    );
  }

  deleteEstablecimientos(
    Clave: string,
    ListaEstablecimientos: Establecimiento[]
  ) {
    return this.http
      .post<void>(`${environment.API_URL}/DeleteEstablecimientos/`, {
        Clave,
        ListaEstablecimientos,
      })
      .pipe(
        catchError(({ error }) => {
          throw error.Message;
        })
      );
  }

  // ** Utilidades ** //

  getTipoDocumentos() {
    return this.http.get<TipoDocumentoModel[]>(
      `${environment.API_URL}/TipoDocumentos/`
    );
  }

  comprobarCorreo(email: string) {
    return this.http.get<number>(
      `${environment.API_URL}/ValidacionRegistroCorreo?Correo=` + email
    );
  }
}
